export const PLACEMENT_SKIN_COLOR = 'POPColor';

export const PLACEMENT_SITE = 'POPSite';

export const PLACEMENT_BODY = 'POPBody';

export const PLACEMENT_HEAD = 'POPHead';

export const PLACEMENT_OTHER = 'POPOther';

export const PLACEMENT_BEARD = 'POPBeard';

export const PLACEMENT_BOX = 'POPBox';
export const PLACEMENT_BOX_PACK = 'POPBoxPack';

export const PLACEMENT_PET_PREVIEW = 'POPPetPreview';

export const PLACEMENT_PET_PREVIEW_SECONDARY = 'POPPetPreviewSecondary';

export const PLACEMENT_AP_PREVIEW = 'POPAttachPackPreview';

export const PLACEMENT_AP_PREVIEW_SECONDARY = 'POPAttachPackPreviewSecondary';

export const GROUP_HEAD = 'Head';

export const PLACEMENT_MAIN = 'POPMain';

export const PLACEMENT_TORSO = 'POPTorso';

export const PLACEMENT_TORSO_LOGO = 'POPTorsoLogo';

export const PLACEMENT_STICKERS = 'POPStickers';

export const PLACEMENT_PRODUCTS = 'POPRecommendation';

export const PLACEMENT_PROTECTOR = 'POPProtector';

export const PLACEMENT_DISCREET_PACKAGING = 'POPDiscreetPackaging';

export const PLACEMENT_NOX_NAME_BACKGROUND = 'POPBoxTexture';

export const PLACEMENT_BOX_NAME = 'POPBoxTextureText';

// eslint-disable-next-line max-len
export const PLACEMENT_PETS = ['POPPet1', 'POPPet2', 'POPPet3', 'POPPet4', 'POPPet5', 'POPPet6', 'POPPet7', 'POPPet8', 'POPPet9', 'POPPet10', 'POPPet11', 'POPPet12'];

export const PLACEMENT_PACKS = ['POPAttachPack1', 'POPAttachPack2'];

export const HEAD_STEPS = ['Head', 'Hair', 'Glasses', 'Beard'];

export const HAIR_STEPS = ['Hair', 'Beard'];

export const ACCESSORIES_STEPS = ['Accessories1', 'Accessories2', 'Accessories3'];

export const VIEW_TOGGLE_STEPS = ['Torso', 'Legs', 'Accessories1', 'Accessories2', 'Accessories3', 'Packs', 'Pets'];

export const BOX_VIEWS = ['Box', 'BoxName', 'Main Mini'];

export const NO_EDIT_STEPS = ['Review', 'Checkout'];

export const GROUP_REVIEW = 'Review';

export const GROUP_NAME = 'Name';

export const PETS_LIMIT = 2;

export const ATTACH_PACKS_LIMIT = 2;

export const CLOSING_ANIMATION_DURATION_IN_MS = 200;
